// Transitions
export const FORM_VALID_TRANSITION_QUOTE_DETAILS =
  "sizotsaFuneralCover/quote/transition/formValid";
export const FORM_INVALID_TRANSITION_QUOTE_DETAILS =
  "sizotsaFuneralCover/quote/transition/formInvalid";


export const transitionQuoteDetails = {
  formValid: () => ({ type: FORM_VALID_TRANSITION_QUOTE_DETAILS }),
  formInvalid: () => ({ type: FORM_INVALID_TRANSITION_QUOTE_DETAILS }),
};

// Transition - reset state
export const RESET_STATE_TRANSITION_QUOTE_DETAILS =
  "sizotsaFuneralCover/quoteDetails/transition/resetState";
export const resetPersonalDetails = () => ({
  type: RESET_STATE_TRANSITION_QUOTE_DETAILS,
});
export const RESET_ME_AND_MY_DIRECT_FAMILY_STATE_TRANSITION=RESET_STATE_TRANSITION_QUOTE_DETAILS+"/meAndMyDirectFamily"
export const resetMeAndMyDirectFamily=()=>({
  type: RESET_ME_AND_MY_DIRECT_FAMILY_STATE_TRANSITION,
})

// Events
export const SIZOTSA_INSURANCE_QUOTE_SIDE_DRAWER =
  "sizotsaFuneralCover/quoteSideDrawer/";
export const QUOTE_DETAILS_DRAWER_SET_VALUE =
SIZOTSA_INSURANCE_QUOTE_SIDE_DRAWER+"setValue/";
export const setQuoteDrawerValue =(value)=>({type: QUOTE_DETAILS_DRAWER_SET_VALUE, value})


export const QUOTE_DETAILS_STATE_SET_VALUE =
SIZOTSA_INSURANCE_QUOTE_SIDE_DRAWER+"setStateValue";
export const setQuoteDetailsStateValue =(value)=>({type: QUOTE_DETAILS_STATE_SET_VALUE, value})


//Synch Form According to Events
export const SYNCH_SIZOTSA_INSURANCE_FORM =
  "sizotsaFuneralCover/synchFormValues/";
export const SYNCH_SIZOTSA_INSURANCE_FORM_VALUES =
SYNCH_SIZOTSA_INSURANCE_FORM+"synchFormValuesBasisOfCoverType/";
export const RESET_SIZOTSA_INSURANCE_FORM_VALUES =
SYNCH_SIZOTSA_INSURANCE_FORM +"resetFormValues/";

export const synchFormValue =(value)=>({type: SYNCH_SIZOTSA_INSURANCE_FORM_VALUES, value})
export const resetFormValues =(value)=>({type: RESET_SIZOTSA_INSURANCE_FORM_VALUES, value})

export const SYNC_BENEFICIARY_DETAILS=SYNCH_SIZOTSA_INSURANCE_FORM+"syncBeneficiaryDetailsFromLivesCovered"
export const synchBeneficiaryDetails =(value)=>({type: SYNC_BENEFICIARY_DETAILS, value})


//form values
export const SIZOTSA_INSURANCE_QUOTE_DETAILS =
  "sizotsaFuneralCover/quoteDetails/";
export const QUOTE_DETAILS_FORM_SET_VALUE =
SIZOTSA_INSURANCE_QUOTE_DETAILS+"setValue/";
export const QUOTE_DETAILS_FORM_SET_VALID =
SIZOTSA_INSURANCE_QUOTE_DETAILS +"setValid/";

export const setQuoteDetailsValue =(value)=>({type: QUOTE_DETAILS_FORM_SET_VALUE, value})
export const setQuoteDetailsFieldValid =(error,fieldType)=>({type: QUOTE_DETAILS_FORM_SET_VALID, error, fieldType})
// export const setPersonalDetailsEdit =(value)=>({type: PERSONAL_DETAILS_EDIT, value})

//synch personaldetails with main member
export const SYNCH_WITH_MAIN_MEMBER = 
  "sizotsaFuneralCover/synchWithMainMember/";
export const SYNCH_PERSONAL_DETAILS_WITH_MAIN_MEMBER_SET_VALUE =
SYNCH_WITH_MAIN_MEMBER+"synchValue/";

export const synchPersonalDetailsWithMainMember = (value) => ({type:SYNCH_PERSONAL_DETAILS_WITH_MAIN_MEMBER_SET_VALUE,value})


//middleWare actions
export const ADD_TO_QUOTE =
SIZOTSA_INSURANCE_QUOTE_DETAILS+"addToQuote";
export const addToQuote =(value)=>({type: ADD_TO_QUOTE, value})

export const REMOVE_MEMBER =
SIZOTSA_INSURANCE_QUOTE_DETAILS+"removeMember";
export const removeMember =(value)=>({type: REMOVE_MEMBER, value})

export const EDIT_QUOTE =
SIZOTSA_INSURANCE_QUOTE_DETAILS+"editQuote";
export const editQuote =(value)=>({type: EDIT_QUOTE, value})

export const ADD_TO_QUOTE_VALIDATED=SIZOTSA_INSURANCE_QUOTE_DETAILS+'validated/addToQuoteValidated';
export const  addToQuoteValidated=(value)=>({type: ADD_TO_QUOTE_VALIDATED, value})

export const SYNC_MAIN_MEMBER_PREMIUM=SYNCH_SIZOTSA_INSURANCE_FORM+"syncMainMembersPeremium"
export const synchMainMemberPremium =(value)=>({type: SYNC_MAIN_MEMBER_PREMIUM, value})

export const SYNC_OTHER_MEMBERS_COVER_AMOUNT=SYNCH_SIZOTSA_INSURANCE_FORM+"syncOtherMembersCoverAmount"
export const synchOtherMembersPremium =()=>({type: SYNC_OTHER_MEMBERS_COVER_AMOUNT})

export const SET_POPUP_MODAL_VALUE = SIZOTSA_INSURANCE_QUOTE_DETAILS+'popUpmodal/setPopupModalValue'
export const setPopupModalValue = (value)=>({type:SET_POPUP_MODAL_VALUE,value})

export const SYNC_DIRECT_MEMBERS_COVER_AMOUNT=SYNCH_SIZOTSA_INSURANCE_FORM+"syncDirectMembersCoverAmount"
export const syncDirectMembersCoverAmount =(value)=>({type:SYNC_DIRECT_MEMBERS_COVER_AMOUNT , value})

export const UPDATE_PREMIUM_PAIDUP_ON_DOB_EDIT=SIZOTSA_INSURANCE_QUOTE_DETAILS+"updatePremiumPaidupOndobEdit"
export const updatePremiumPaidupOndobEdit =()=>({type: UPDATE_PREMIUM_PAIDUP_ON_DOB_EDIT})

export const SYNC_EXISTING_MEMBERS_DATA=SIZOTSA_INSURANCE_QUOTE_DETAILS+"syncExistingMembersData"
export const syncBeneficiariWithLivesCovered =(value)=>({type: SYNC_EXISTING_MEMBERS_DATA,value})